import { useMutation } from 'react-query'
import { postApplyPromoCode } from '../api'

const useApplyPromoCode = () => {
    const { mutateAsync, isLoading, isSuccess } =
        useMutation(postApplyPromoCode)
    return { mutateAsync, isLoading, isSuccess }
}

export default useApplyPromoCode
